import { failure, inProgress, notAsked, RemoteData, success } from 'ngx-remotedata';
import { ErrorWrapper } from '@trade-platform/ui-shared';
import { OrderFormsCompleteActions, OrderFormsCompleteActionTypes } from './actions';

export type OrderFormsCompleteState = RemoteData<null, ErrorWrapper>;
const initialState = notAsked<null, ErrorWrapper>();

export const orderFormsCompleteReducer = (
    state: OrderFormsCompleteState = initialState,
    action: OrderFormsCompleteActions
): OrderFormsCompleteState => {
    switch (action.type) {
        case OrderFormsCompleteActionTypes.ORDER_FORMS_COMPLETE:
            return inProgress();
        case OrderFormsCompleteActionTypes.ORDER_FORMS_COMPLETE_SUCCESS:
            return success(null);
        case OrderFormsCompleteActionTypes.ORDER_FORMS_COMPLETE_FAILURE:
            return failure(action.payload.error);
        default:
            return state;
    }
};
